<template>
  <section>
    <div id="chart"></div>
  </section>
</template>

<script>
import * as d3 from "d3";
import c3 from "c3";
import * as pym from "pym.js";
import "c3/c3.min.css";

var pymChild = new pym.Child();

export default {
  props: {
    jobs: {
      type: Array
    },
    selection: {
      type: String
    }
  },
  computed: {
    selData() {
      var filtered = this.jobs.filter(d => {
        return d["Occupation"] == this.selection;
      });
      filtered.sort(function(x, y) {
        return d3.descending(
          +x["Annual Mean Income"],
          +y["Annual Mean Income"]
        );
      });
      return filtered;
    }
  },
  watch: {
    selection() {
      var t = this,
        max = data => {
          var m = [];
          data.forEach(function(d) {
            m.push(d["Annual Mean Income"]);
          });
          var r = parseInt(d3.max(m)) / 10000
          return (r + .5) * 10000;
        },
        text = () => {
          var w = parseInt(d3.select("#chart").style("width"));
          return w >= 800 ? 200 : w < 600 ? 150 : w / 3;
        },
        chart = c3.generate({
          data: {
            color: () => {return '#27bbe0'},
            json: t.selData,
            type: "bar",
            keys: {
              x: "Industry",
              value: ["Annual Mean Income"]
            },
            labels: {
              format: function(v) {
                var dollars = d3.format("$.2s");
                return dollars(v).toUpperCase();
              }
            }
          },
          axis: {
            x: {
              type: "category",
              tick: {
                width: text(),
                multiline: true
              }
            },
            y: {
              show: false,
              tick: {
                show: false,
                count: 1,
                format: function(v) {
                  var dollars = d3.format("$.2s");
                  return v > 0 ? dollars(v).toUpperCase() : 0;
                }
              }
            },
            rotated: true
          },
          bar: {
            width: {
              ratio: 0.75
            }
          },
          grid: {
            y: {
              show: true
            }
          },
          legend: {
            show: false
          },
          padding: {
            left: text() + 20
          },
          size: {
            height: (t.selData.length * 10 - (t.selData.length - 1) * 4) * 10
          },
          tooltip: {
           show: false
          },
          onresize: function() {
            chart.flush();
            pymChild.sendHeight()
          }
        });
        pymChild.sendHeight()
    }
  }
};
</script>

<style lang="scss">
#chart {
  svg {
    max-width: 100%;
    overflow: visible !important;
    pointer-events: none;
  }
  text {
    font-size: 13px;
    fill: #000 !important;
    @media screen and (max-width: 800px) {
      font-size: 12px;
    }
    @media screen and (max-width: 600px) {
      font-size: 11px;
    }
  }
  g.tick:last-child line {
    fill: #000 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Graph.vue